import React from 'react';
import { FileTextIcon, PrinterIcon, DownloadIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const details = [{
  icon: FileTextIcon,
  label: 'Every volume and bonus is a PDF'
}, {
  icon: PrinterIcon,
  label: 'Print any page or hand it out digitally'
}, {
  icon: DownloadIcon,
  label: 'Download instantly after checkout'
}];
export function FormatNotice() {
  return <section aria-labelledby="format-heading" className="bg-night-900 py-14 sm:py-20" data-id="element-155" data-mp="2y2nwxth9cgdp">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-156" data-mp="323zlrwsb4xku">
        <Eyebrow align="center" data-id="element-157" data-mp="3237pejqvyvti">Format</Eyebrow>
        <h2 id="format-heading" className="mt-4 font-display text-3xl leading-[0.98] text-cream sm:text-5xl" data-id="element-158" data-mp="2od4akduc64e3">
          All the content is PDF. <span className="text-amber" data-id="element-159" data-mp="2t9l1ffsx6wuv">No videos for now.</span>
        </h2>
        <p className="mt-5 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-160" data-mp="3gzp3hiqgmojr">
          Printable, editable documents you can use straight in class &mdash; no platform to log
          into, no video course to sit through.
        </p>

        <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-3 sm:text-center" data-id="element-161" data-mp="2du8pe661wgym">
          {details.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-3 rounded-xl border border-night-600 bg-night-800 p-4 sm:flex-col" data-id="element-162" data-mp="2rmyam8dr9huo">
              <Icon className="h-5 w-5 shrink-0 text-amber" aria-hidden="true" data-id="element-163" data-mp="31irxolp3otqp" />
              <span className="text-xs leading-snug text-cream-soft" data-id="element-164" data-mp="2wkqc9u47cic2">{label}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}